import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumAssemblyIngredientSource implements BaseEnumType {
  private static allValues: EnumAssemblyIngredientSource[] = []; // make sure this is top-most
  
  public static stock = new EnumAssemblyIngredientSource(0, "Stock", "enum_assembly_ingredient_source_stock");
  public static assembly = new EnumAssemblyIngredientSource(1, "Assembly", "enum_assembly_ingredient_source_assembly");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumAssemblyIngredientSource.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isStock() { return this === EnumAssemblyIngredientSource.stock; }
  public isAssembly() { return this === EnumAssemblyIngredientSource.assembly; }

  public static getValues(): readonly EnumAssemblyIngredientSource[] {
    return EnumAssemblyIngredientSource.allValues;
  }

  public static getValuesExcept0(): readonly EnumAssemblyIngredientSource[] {
    return EnumAssemblyIngredientSource.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumAssemblyIngredientSource {
    const found = EnumAssemblyIngredientSource.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumAssemblyIngredientSource - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumAssemblyIngredientSource): EnumAssemblyIngredientSource {
    const found = name ? EnumAssemblyIngredientSource.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumAssemblyIngredientSource - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumAssemblyIngredientSource>): boolean {
    return this.key === other?.key;
  }
}